// extracted by mini-css-extract-plugin
export default {"mobileBurger":"Mobileburger_mobileBurger__Bwgtm"};